import { IHttpMethodConfig } from 'services/http/types';
import { apiFunctionsEnum } from 'constants/api.constants';

export const apiConnectorMethods: Partial<Record<apiFunctionsEnum, IHttpMethodConfig>> = {
	getFeaturesByCategory: {
		endpoint: '/bo-content/content/category/features',
		httpMethod: 'post',
		validation: {
			category: {
				required: true,
				type: 'string',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getPagesByFeature: {
		endpoint: '/bo-content/content/feature/pages',
		httpMethod: 'post',
		validation: {
			category: {
				required: true,
				type: 'string',
			},
			feature: {
				required: true,
				type: 'string',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getLanguages: {
		endpoint: '/bo-content/languages',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	saveFile: {
		endpoint: '/bo-content/content/image/save',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	saveTranslations: {
		endpoint: '/bo-content/content/page/save',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getBalancesReport: {
		endpoint: '/reports/report/balances',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getBeneficiariesReport: {
		endpoint: '/reports/report/beneficiary',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getBeneficiaryOnboardingReport: {
		endpoint: '/reports/report/beneficiary-onboarding',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getNewUsersByAccountId: {
		endpoint: '/new-users/new-account/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getNewBankAccountsByAccountId: {
		endpoint: '/new-bank-accounts/new-account/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	approveNewAccountBankAccounts: {
		endpoint: '/new-bank-accounts/approve',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	approveNewAccountUsers: {
		endpoint: '/new-users/approve',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	approveNewAccountCustomerDetails: {
		endpoint: '/new-accounts/approve',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	approveNewAccount: {
		endpoint: '/new-accounts/approve-all',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompaniesReport: {
		endpoint: '/reports/report/companies',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getTransactionsReport: {
		endpoint: '/reports/report/transactions',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getRefundsReport: {
		endpoint: '/reports/report/refunds',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getConversionFeesReport: {
		endpoint: '/reports/report/conversion-fees',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPaymentFeesReport: {
		endpoint: '/reports/report/payment-fees',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getAccountActivitiesReport: {
		endpoint: '/reports/report/account-activities',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanies: {
		endpoint: '/companies/get-companies',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompaniesExpendedData: {
		endpoint: '/companies/get-companies-expended-data',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getMyPermissions: {
		endpoint: '/permission/self',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getBusinessModelPlans: {
		endpoint: '/business-model/get-business-plans',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCoinsCouples: {
		endpoint: '/business-model/get-coins-couples',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getExistContact: {
		endpoint: '/new-users/getExistContact',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	updateExistingCoinsCouple: {
		endpoint: '/business-model/update-coins-couple',
		httpMethod: 'post',
		validation: {
			sourceCurrencyId: {
				required: true,
				type: 'number',
			},
			targetCurrencyId: {
				required: true,
				type: 'number',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	createNewCoinsCouple: {
		endpoint: '/business-model/create-coins-couple',
		httpMethod: 'post',
		validation: {
			sourceCurrencyId: {
				required: true,
				type: 'number',
			},
			targetCurrencyId: {
				required: true,
				type: 'number',
			},
			isActive: {
				required: true,
				type: 'boolean',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getCurrencies: {
		endpoint: '/allowed-currencies',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
		skipRecaptcha: true,
	},
	getCurrenciesToDisplay: {
		endpoint: '/balance/get-currencies-to-display',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
		skipRecaptcha: true,
	},
	saveBusinessPlan: {
		endpoint: '/business-model/save-business-plans',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPendingRequestsAnalytics: {
		endpoint: '/pending-requests/get-analytics',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_WEBHOOK_MONITORING_ANALYTICS]: {
		endpoint: '/webhook-monitoring/get-analytics',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_WEBHOOK_MONITORING_OPERATIONS]: {
		endpoint: '/webhook-monitoring/operations/:status',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_WEBHOOK_MONITORING_OPERATION_DETAILS]: {
		endpoint: '/webhook-monitoring/operations/:operationId/details',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.REPLAY_WEBHOOK_MONITORING_OPERATION]: {
		endpoint: '/webhook-monitoring/operations/replay',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_WEBHOOK_MONITORING_HEALTHCHECK]: {
		endpoint: '/webhook-monitoring/healthcheck',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_HYPER_MONITORING_ANALYTICS]: {
		endpoint: '/hyper-monitoring/get-analytics',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_HYPER_MONITORING_OPERATIONS]: {
		endpoint: '/hyper-monitoring/operations/:status',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.RESEND_HYPER_MONITORING_OPERATION]: {
		endpoint: '/hyper-monitoring/operations/resend',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.MARK_HYPER_MONITORING_OPERATION_DOCUMENTED]: {
		endpoint: '/hyper-monitoring/operations/mark-documented',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	approve_beneficiary: {
		endpoint: '/beneficiary/approve',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	read_beneficiary: {
		endpoint: '/beneficiary/:beneficiaryId',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	approve_bank_account: {
		endpoint: '/new-bank-accounts/company/upsert',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	read_bank_account: {
		endpoint: '/new-bank-accounts/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	approve_support_request: {
		endpoint: '/support-requests/close',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	update_support_request_status: {
		endpoint: '/support-requests/update-status',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	read_support_request: {
		endpoint: '/support-requests/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	approve_payment: {
		endpoint: '/payments/approve',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	available_payment_days: {
		endpoint: '/payments/available-payment-days',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	read_payment: {
		endpoint: '/payments/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	approve_balance: {
		endpoint: '/balance/approve-add-balance',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	read_balance: {
		endpoint: '/balance/activity/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	approve_account: {
		endpoint: '/new-users/requests/approve',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	resend_welcome_email: {
		endpoint: '/new-users/requests/resend_welcome_email',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	read_account: {
		endpoint: '/contact-requests/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},

	getHouseAccountBalances: {
		endpoint: '/balance/house-account-balance',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getAllCompanyBalances: {
		endpoint: '/balance/get-all-company-balances',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getAccountBalance: {
		endpoint: '/balance/get-account-balance',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPendingBalance: {
		endpoint: '/balance/get-pending-balance',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getConversionFees: {
		endpoint: '/balance/get-conversion-fees',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPaymentFees: {
		endpoint: '/balance/get-payment-fees',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPlanFees: {
		endpoint: '/balance/get-plan-fees',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPlanFeesByCompany: {
		endpoint: '/balance/get-plan-fees-by-company',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getTotalRevenueByCompany: {
		endpoint: '/balance/get-total-revenue-by-company',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getAverageIncomeFromCustomer: {
		endpoint: '/balance/get-average-income-from-customer',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getBeneficiaryStatusSummary: {
		endpoint: '/beneficiary-dashboard/status-summary',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_BENEFICIARY_DASHBOARD_BENEFICIARIES]: {
		endpoint: '/beneficiary-dashboard/beneficiaries',
		httpMethod: 'get',
		skipRecaptcha: true,
	},
	[apiFunctionsEnum.GET_BENEFICIARY_RESPONSE_TIME_SUMMARY]: {
		endpoint: '/beneficiary-dashboard/response-time-summary',
		httpMethod: 'post',
		skipRecaptcha: true,
	},
	getBenefits: {
		endpoint: '/benefits',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	createBenefit: {
		endpoint: '/benefits/create',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	updateBenefitStatus: {
		endpoint: '/benefits/update',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	createRefund: {
		endpoint: '/refunds/create',
		httpMethod: 'post',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getBankList: {
		endpoint: '/banks',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.UPDATE_BANK_DIGITAL_DEPOSIT_AVAILABILITY]: {
		endpoint: '/banks/update-digital-deposit-availability',
		httpMethod: 'post',
		validation: {
			bankId: {
				required: true,
				type: 'number',
			},
			isDigitalDepositTemporarilyUnavailable: {
				required: true,
				type: 'boolean',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getAccountsBySearch: {
		endpoint: '/companies/free-text-search-account',
		httpMethod: 'post',
		validation: {
			searchWord: {
				required: true,
				type: 'string',
			},
			searchType: {
				required: true,
				type: 'string',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getCountries: {
		endpoint: '/countries',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getIndustries: {
		endpoint: '/industries',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getPaymentsPurpose: {
		endpoint: '/payments-purpose',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editCountry: {
		endpoint: '/edit-country',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editPaymentsPurpose: {
		endpoint: '/upsert-payments-purpose',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editPaymentStatus: {
		endpoint: '/payments/edit-status',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCustomerDashboard: {
		endpoint: '/companies/get-company-data',
		skipRecaptcha: true,
		httpMethod: 'post',
		validation: {
			id: {
				required: true,
				type: 'number',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBeneficiaries: {
		endpoint: '/companies/:id/beneficiaries',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyContactById: {
		endpoint: '/companies/:id/contacts/:contactId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBeneficiaryById: {
		endpoint: '/companies/:id/beneficiaries/:beneficiaryId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBeneficiaryPayments: {
		endpoint: '/companies/:id/beneficiaries/:beneficiaryId/payments',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBeneficiaryHyperSyncState: {
		endpoint: '/companies/:id/beneficiaries/:beneficiaryId/hyper-sync-state',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBankAccountById: {
		endpoint: '/companies/:id/bank-accounts/:bankAccountId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyPaymentById: {
		endpoint: '/companies/:id/payments/:paymentId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyConversionById: {
		endpoint: '/companies/:id/conversions/:conversionId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBalanceById: {
		endpoint: '/companies/:id/balances/:balanceId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBalanceRefundById: {
		endpoint: '/companies/:id/balance-refunds/:refundId',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyActivities: {
		endpoint: '/companies/:id/activities',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBankAccounts: {
		endpoint: '/companies/:id/bank-accounts',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanySupportRequests: {
		endpoint: '/companies/:id/support-requests',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getCompanyBalances: {
		endpoint: '/companies/:id/balances',
		skipRecaptcha: true,
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	upsertCustomerRelations: {
		endpoint: '/companies/upsert-customer-relations',
		httpMethod: 'post',
		validation: {
			id: {
				required: false,
				type: 'number',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	getBoSignerAllBalanceRequests: {
		endpoint: '/balance/requests',
		httpMethod: 'get',
		skipRecaptcha: true,
		headers: {},
		additionalConfigurations: {},
	},
	getBoSignerBalanceRequestsByStatus: {
		endpoint: '/balance/requests/:status',
		httpMethod: 'get',
		skipRecaptcha: true,
		headers: {},
		additionalConfigurations: {},
	},
	getAltshulerEmployees: {
		endpoint: '/companies/get-altshuler-employees',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	upsert_account: {
		endpoint: '/new-accounts/upsert',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	upsert_user: {
		endpoint: '/new-users/upsert',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	delete_user: {
		endpoint: '/new-users/delete',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	delete_bank_account: {
		endpoint: '/new-bank-accounts/delete',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	upsert_bank_account: {
		endpoint: '/new-bank-accounts/upsert',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	get_new_account_by_id: {
		endpoint: '/new-accounts/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getNewAccounts: {
		endpoint: '/new-accounts',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	verifyCloseAccount: {
		endpoint: '/companies/verify-close-company',
		httpMethod: 'post',
		validation: {
			companyId: {
				required: true,
				type: 'number',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	closeAccount: {
		endpoint: '/companies/close-company',
		httpMethod: 'post',
		validation: {
			companyId: {
				required: true,
				type: 'number',
			},
			closeRequestByContactId: {
				required: true,
				type: 'number',
			},
			closeReason: {
				required: true,
				type: 'string',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	send_account_to_review: {
		endpoint: '/new-accounts/review',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editCompanyData: {
		endpoint: '/companies/edit-company-data',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editContactData: {
		endpoint: '/companies/edit-contact-data',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editBankAccountData: {
		endpoint: '/companies/edit-company-bank-data',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	editBeneficiary: {
		endpoint: '/beneficiary/edit-beneficiary',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	getAltshulerBankAccounts: {
		endpoint: '/balance/altshuler-accounts',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	createBalance: {
		endpoint: '/balance/create-add-balance',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	createWithdrawalBalance: {
		endpoint: '/balance/create-bo-withdrawal',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	boSignerApproveBalance: {
		endpoint: '/balance/bo-signer-approve-add-balance',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	readFile: {
		endpoint: '/companies/file/read/:key/:companyId',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	withdrawlWaitHouseAccountApproval: {
		endpoint: '/balance/withdrawal-wait',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	transferDetailsHouseToAltshulerAccount: {
		endpoint: '/balance/transfer/house-to-altshuler-bank',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	transferDetailsFinalCustomerBankAccount: {
		endpoint: '/balance/transfer/final-bank',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	boSignerDeclineBalance: {
		endpoint: '/balance/decline-add-balance',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	createSupportWithdrawalRequest: {
		endpoint: '/support-requests/withdrawal',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	readFileByKey: {
		endpoint: '/new-accounts/file/:key',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_COMPANY_BENEFITS]: {
		endpoint: '/benefits/company',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.ADD_COMPANY_BENEFIT]: {
		endpoint: '/benefits/company/add',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.UPDATE_COMPANY_BENEFIT_STATUS]: {
		endpoint: '/benefits/company/status',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.SEND_EMAIL_EXAMPLE]: {
		endpoint: '/bo-content/email-example',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.UPDATE_DIGITAL_BALANCE_DOCUMENTED_IN_HYPER]: {
		endpoint: '/pending-requests/update-digital-balance-documented-in-hyper',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_ALL_FEATURE_FLAGS]: {
		endpoint: '/feature-flags/all',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.UPDATE_FEATURE_FLAG]: {
		endpoint: '/feature-flags/update',
		httpMethod: 'post',
		validation: {
			name: {
				required: true,
				type: 'string',
			},
			isEnabled: {
				required: true,
				type: 'boolean',
			},
			description: {
				required: false,
				type: 'string',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_ALL_SYSTEM_SETTINGS]: {
		endpoint: '/system-settings/all',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.UPDATE_SYSTEM_SETTING]: {
		endpoint: '/system-settings/update',
		httpMethod: 'post',
		validation: {
			domain: {
				required: true,
				type: 'string',
			},
			key: {
				required: true,
				type: 'string',
			},
			value: {
				required: true,
				type: 'string',
			},
		},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_COMPLETED_DIGITAL_BALANCE_REQUESTS]: {
		endpoint: '/balance/completed-digital-balance-requests',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_DUPLICATE_BALANCE_ADDITION_COMPANIES]: {
		endpoint: '/balance/duplicate-balance-addition-companies',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.EDIT_DIGITAL_BALANCE_STATUS]: {
		endpoint: '/balance/edit-digital-balance-status',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	// Payment Categories
	[apiFunctionsEnum.GET_PAYMENT_CATEGORIES]: {
		endpoint: '/payment-categories/tree',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PAYMENT_CATEGORY]: {
		endpoint: '/payment-categories/:id',
		httpMethod: 'get',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.CREATE_PAYMENT_CATEGORY]: {
		endpoint: '/payment-categories/create',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.UPDATE_PAYMENT_CATEGORY]: {
		endpoint: '/payment-categories/update',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.TOGGLE_PAYMENT_CATEGORY_ACTIVE]: {
		endpoint: '/payment-categories/toggle-active',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.PAYMENT_CATEGORIES_TRANSLATIONS]: {
		endpoint: '/bo-content/content/feature/pages',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.SYNC_PAYMENT_CATEGORIES_TO_COMPANIES]: {
		endpoint: '/payment-categories/sync-to-companies',
		httpMethod: 'post',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.DELETE_NEW_ACCOUNT_AND_COMPANY]: {
		endpoint: '/new-accounts/:id',
		httpMethod: 'delete',
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	// Paginated pending requests
	[apiFunctionsEnum.GET_PENDING_BANK_ACCOUNTS]: {
		endpoint: '/pending-requests/bank-accounts',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PENDING_BALANCES]: {
		endpoint: '/pending-requests/balances',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PENDING_BENEFICIARIES]: {
		endpoint: '/pending-requests/beneficiaries',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PENDING_PAYMENTS]: {
		endpoint: '/pending-requests/payments',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PENDING_WITHDRAWALS]: {
		endpoint: '/pending-requests/withdrawals',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PENDING_WITHDRAWALS_BO_APPROVED]: {
		endpoint: '/pending-requests/withdrawals-bo-approved',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.GET_PENDING_BALANCES_BO]: {
		endpoint: '/pending-requests/balances-bo',
		httpMethod: 'get',
		skipRecaptcha: true,
		validation: {},
		headers: {},
		additionalConfigurations: {},
	},
	[apiFunctionsEnum.CREATE_SYSTEM_MESSAGE]: {
		endpoint: '/system-messages',
		httpMethod: 'post',
	},
	[apiFunctionsEnum.CREATE_SYSTEM_MESSAGE_COMPANY]: {
		endpoint: '/system-messages/company',
		httpMethod: 'post',
	},
	[apiFunctionsEnum.GET_SYSTEM_MESSAGES]: {
		endpoint: '/system-messages',
		httpMethod: 'get',
	},
	[apiFunctionsEnum.GET_SYSTEM_MESSAGE_BY_ID]: {
		endpoint: '/system-messages/:id',
		httpMethod: 'get',
	},
	[apiFunctionsEnum.DISABLE_SYSTEM_MESSAGE]: {
		endpoint: '/system-messages/disable',
		httpMethod: 'post',
	},
	[apiFunctionsEnum.VALIDATE_CONTACT_IDS]: {
		endpoint: '/system-messages/validate-contact-ids',
		httpMethod: 'post',
	},
	[apiFunctionsEnum.GET_COMPANY_SYSTEM_MESSAGES]: {
		endpoint: '/system-messages/company/:companyId',
		httpMethod: 'get',
		skipRecaptcha: true,
	},
	[apiFunctionsEnum.GET_COMPANY_SYSTEM_MESSAGE_BY_ID]: {
		endpoint: '/system-messages/company/:companyId/:id',
		httpMethod: 'get',
		skipRecaptcha: true,
	},
};
